import getProviderFunc from './getProvider';
import App from './app';
import Fund from './fund';
import Market from './market';
import User from './user';
import Console from './console';
import Account from './account';
import Message from './message';
import Coupon from './coupon';
import RedPacket from './redPacket';
import Finance from './finance';
import FiveYearsAnniversaryModal from './fiveYearsAnniversary';

class RootStore {
  app: App;
  fund: Fund;
  market: Market;
  user: User;
  consl: Console;
  account: Account;
  message: Message;
  coupon: Coupon
  
  redPacket: RedPacket;
  finance: Finance;
  fiveYears: FiveYearsAnniversaryModal;
  
  constructor() {
    this.app = new App();
    this.fund = new Fund();
    this.market = new Market();
    this.user = new User();
    this.consl = new Console();
    this.account = new Account();
    this.message = new Message();
    this.coupon = new Coupon();
    this.redPacket = new RedPacket();
    this.finance = new Finance(this);
    this.fiveYears = new FiveYearsAnniversaryModal();
  }

  init(appState){
    this.fund.init(appState);
    this.market.init(appState);
    this.user.init(appState);
    this.fiveYears.init();
  }
}

const stores = new RootStore();

export default stores;

export const { StoreProvider, useStore } = getProviderFunc<typeof stores>();
